export const calculateTotalPages = (array, pageSize) => {
  return Math.ceil(array.length / pageSize);
};

export const paginateArray = (array, pageNumber, pageSize) => {
  const startIndex = (pageNumber - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  return array.slice(startIndex, endIndex);
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // You can use "auto" for instant scrolling
  });
};
